const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5334px",
    height: "3205px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#5397e9",
    d: "M 2893.5,677.5 C 2892.5,866.333 2892.17,1055.33 2892.5,1244.5C 3080.83,1244.5 3269.17,1244.5 3457.5,1244.5C 3457.67,1692.5 3457.5,2140.5 3457,2588.5C 3453.17,2603 3444,2612.17 3429.5,2616C 2920.5,2616.67 2411.5,2616.67 1902.5,2616C 1887.82,2611.32 1878.65,2601.49 1875,2586.5C 1874.33,1960.17 1874.33,1333.83 1875,707.5C 1878.84,689.326 1890.01,679.159 1908.5,677C 2237,676.167 2565.33,676.334 2893.5,677.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#0070ca",
    d: "M 2893.5,677.5 C 3081.47,865.632 3269.3,1053.97 3457,1242.5C 3457.46,1243.09 3457.63,1243.76 3457.5,1244.5C 3269.17,1244.5 3080.83,1244.5 2892.5,1244.5C 2892.17,1055.33 2892.5,866.333 2893.5,677.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 2792.5,1287.5 C 2794,1312.33 2807,1326.66 2831.5,1330.5C 3014.67,1331.5 3198,1331.83 3381.5,1331.5C 3381.5,1730.5 3381.5,2129.5 3381.5,2528.5C 2912.83,2528.5 2444.17,2528.5 1975.5,2528.5C 1975.5,1943.83 1975.5,1359.17 1975.5,774.5C 2247.5,774.5 2519.5,774.5 2791.5,774.5C 2791.17,945.667 2791.5,1116.67 2792.5,1287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#d5e5f9",
    d: "M 2792.5,1287.5 C 2791.5,1116.67 2791.17,945.667 2791.5,774.5C 2519.5,774.5 2247.5,774.5 1975.5,774.5C 1975.5,1359.17 1975.5,1943.83 1975.5,2528.5C 1975.5,2528.83 1975.5,2529.17 1975.5,2529.5C 1974.5,1944.33 1974.17,1359 1974.5,773.5C 2247.17,773.5 2519.83,773.5 2792.5,773.5C 2792.5,944.833 2792.5,1116.17 2792.5,1287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5397e9",
    d: "M 2261.5,1646.5 C 2515.17,1646.33 2768.83,1646.5 3022.5,1647C 3046.57,1651.4 3061.07,1665.57 3066,1689.5C 3066.67,1710.17 3066.67,1730.83 3066,1751.5C 3060.27,1773.9 3046.1,1787.4 3023.5,1792C 2769.17,1792.67 2514.83,1792.67 2260.5,1792C 2237.9,1787.4 2223.73,1773.9 2218,1751.5C 2217.33,1730.83 2217.33,1710.17 2218,1689.5C 2223.12,1665.54 2237.62,1651.21 2261.5,1646.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5397e9",
    d: "M 2258.5,1881.5 C 2513.83,1881.33 2769.17,1881.5 3024.5,1882C 3048.36,1887.53 3062.19,1902.36 3066,1926.5C 3066.67,1945.83 3066.67,1965.17 3066,1984.5C 3061.05,2008.45 3046.55,2022.61 3022.5,2027C 2768.83,2027.67 2515.17,2027.67 2261.5,2027C 2237.46,2022.62 2222.96,2008.46 2218,1984.5C 2217.33,1963.83 2217.33,1943.17 2218,1922.5C 2223.67,1901 2237.17,1887.33 2258.5,1881.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5397e9",
    d: "M 2257.5,2116.5 C 2513.83,2116.33 2770.17,2116.5 3026.5,2117C 3047.44,2122.94 3060.61,2136.44 3066,2157.5C 3066.67,2178.17 3066.67,2198.83 3066,2219.5C 3061.05,2241.12 3047.88,2254.95 3026.5,2261C 2770.17,2261.67 2513.83,2261.67 2257.5,2261C 2236.15,2254.98 2222.98,2241.14 2218,2219.5C 2217.33,2198.83 2217.33,2178.17 2218,2157.5C 2223.61,2136.39 2236.78,2122.72 2257.5,2116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#dfebfb",
    d: "M 2831.5,1330.5 C 3015.17,1330.5 3198.83,1330.5 3382.5,1330.5C 3382.5,1730.17 3382.5,2129.83 3382.5,2529.5C 2913.5,2529.5 2444.5,2529.5 1975.5,2529.5C 1975.5,2529.17 1975.5,2528.83 1975.5,2528.5C 2444.17,2528.5 2912.83,2528.5 3381.5,2528.5C 3381.5,2129.5 3381.5,1730.5 3381.5,1331.5C 3198,1331.83 3014.67,1331.5 2831.5,1330.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.e4a9f7e83c3577ea73887286e65797f4.svg";
export { ForwardRef as ReactComponent };